export default __webpack_public_path__ + "fonts/tpl_9.f3ff73a60873dd0b6caf78477cdbbe53.png";